import { motion } from "framer-motion";
import { Navbar, FinalCTA, Waveform, fadeUp, staggerContainer, btnMotion } from "../components/Shared";

const PILLARS = [
  "Confidential Wellness Coaching",
  "Evidence-Based Behavioral Support",
  "Organizational Wellbeing",
  "Manager Enablement",
  "Aggregate Organizational Insight"
];

export default function About() {
  return (
    <main className="cw-about">
      <Navbar />
      
      <section className="cw-section" style={{ paddingTop: 'var(--space-xl)', textAlign: 'center' }}>
        <div className="cw-section__inner">
          <motion.div variants={staggerContainer(0.1)} initial="hidden" animate="visible">
            <motion.p className="cw-eyebrow" variants={fadeUp}>About Us</motion.p>
            <motion.h1 variants={fadeUp} style={{ fontSize: '3rem', marginBottom: 'var(--space-md)' }}>
              We believe individual wellbeing and organizational health are inseparable.
            </motion.h1>
            <motion.p variants={fadeUp} style={{ fontSize: '1.2rem', maxWidth: '650px', margin: '0 auto var(--space-md)', opacity: 0.8 }}>
              Cognito Wellness was founded on a simple premise: you cannot fix employee burnout with a wellness webinar, and you cannot fix a toxic culture by only treating the individual. Both must be addressed together.
            </motion.p>
            <div style={{ display: 'flex', justifyContent: 'center' }}><Waveform /></div>
          </motion.div>
        </div>
      </section>

      <section className="cw-section cw-section--alt">
        <div className="cw-section__inner">
          <motion.p className="cw-eyebrow" style={{ textAlign: 'center' }}>Our Philosophy</motion.p>
          <motion.h2 className="cw-section__title" style={{ textAlign: 'center', fontSize: '2.2rem', marginBottom: 'var(--space-lg)' }}>
            The Cognito Approach
          </motion.h2>
          <motion.div variants={staggerContainer(0.1)} initial="hidden" whileInView="visible" viewport={{ once: true }} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 'var(--space-lg)', alignItems: 'center' }}>
            <div>
              <motion.p variants={fadeUp} style={{ fontSize: '1.1rem', lineHeight: 1.8, marginBottom: 'var(--space-md)' }}>
                Traditional EAPs are reactive, underutilized, and disconnected from the daily realities of work. Standalone wellness apps ignore the manager's critical role in fostering psychological safety. 
              </motion.p>
              <motion.p variants={fadeUp} style={{ fontSize: '1.1rem', lineHeight: 1.8 }}>
                Cognito combines the best of wellness coaching, behavioral support, and organizational wellbeing into a single, continuous loop. We support the person, enable the manager, and inform the leadership.
              </motion.p>
            </div>
            <motion.div className="cw-card" variants={fadeUp} style={{ background: 'var(--cw-offwhite)' }}>
              <h3 style={{ fontFamily: 'var(--font-serif)', fontSize: '1.3rem', marginBottom: 'var(--space-md)' }}>What makes us different:</h3>
              <ul style={{ listStyle: 'none', display: 'grid', gap: 'var(--space-sm)' }}>
                {PILLARS.map((pillar, i) => (
                  <motion.li key={i} variants={fadeUp} style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-xs)', fontFamily: 'var(--font-mono)', fontSize: '0.9rem' }}>
                    <span style={{ color: 'var(--cw-pink)' }}>—</span> {pillar}
                  </motion.li>
                ))}
              </ul>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <section className="cw-section">
        <div className="cw-section__inner" style={{ textAlign: 'center', maxWidth: '700px' }}>
          <motion.p className="cw-eyebrow" variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }}>Our Core Principle</motion.p>
          <motion.h2 variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} style={{ fontSize: '2.5rem', marginBottom: 'var(--space-md)' }}>
            Trust is our foundation.
          </motion.h2>
          <motion.p variants={fadeUp} initial="hidden" whileInView="visible" viewport={{ once: true }} style={{ fontSize: '1.1rem', opacity: 0.8, lineHeight: 1.8 }}>
            If employees do not trust that their data is safe, the platform fails. That is why we engineer our systems with radical transparency and strict confidentiality boundaries. 
            <strong> We do not record sessions.</strong> We do not sell data. We do not report individual usage to HR. We exist to serve the employee first, which in turn, serves the organization.
          </motion.p>
        </div>
      </section>

      <motion.section className="cw-section cw-section--alt" style={{ textAlign: 'center', padding: 'var(--space-xl) var(--space-md)' }} variants={staggerContainer(0.08)} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.4 }}>
        <div className="cw-section__inner">
          <motion.h2 className="cw-section__title" variants={fadeUp} style={{ fontSize: '2.8rem', marginBottom: 'var(--space-sm)' }}>
            Let's Build a Healthier Way of Working.
          </motion.h2>
          <motion.p variants={fadeUp} style={{ marginBottom: 'var(--space-md)', opacity: 0.8 }}>
            Join the organizations that are moving beyond fragmented wellness to true, integrated corporate wellbeing.
          </motion.p>
          <motion.a
            href="mailto:cs@cognitowellness.org?subject=Pilot Inquiry: Cognito Wellness"
            className="cw-btn cw-btn--primary"
            variants={fadeUp}
            {...btnMotion}
          >
            Start a 3-Month Pilot
          </motion.a>
        </div>
      </motion.section>
    </main>
  );
}